import Vue from 'vue'
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import Carousel3d from 'vue-carousel-3d';
import * as VueGoogleMaps from 'vue2-google-maps';
import VueGeolocation from 'vue-browser-geolocation';
import { GmapMarker } from 'vue2-google-maps/src/components/marker';
import VueSwal from 'vue-swal';
// import the plugin
import VueGAPI from 'vue-gapi'
import SequentialEntrance from 'vue-sequential-entrance'
import 'vue-sequential-entrance/vue-sequential-entrance.css'
Vue.use(SequentialEntrance);
export const bus = new Vue();

Vue.config.productionTip = false;


// Use the plugin and pass along the configuration'
// create the 'options' object
const apiConfig = {
  apiKey: 'AIzaSyD9hzDXGNyY5ejQKk-ncb1Iv19N2nh3ABo',
  clientId: '292320827989-nou250q4tjpk0j0h4j5poodgai5km88f.apps.googleusercontent.com',
  discoveryDocs: ['https://www.googleapis.com/discovery/v1/apis/gmail/v1/rest'],
  // see all available scopes here: https://developers.google.com/identity/protocols/googlescopes'
  scope: 'https://www.googleapis.com/auth/gmail.send',

  // works only with `ux_mode: "prompt"`
  refreshToken: true,
}

Vue.use(VueGAPI, apiConfig);
Vue.use(VueSwal);
Vue.use(VueGeolocation);
Vue.component('GmapMarker', GmapMarker)
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCwSEFovFNJ9L_47CuTBIGGJ4qntTOJmrM',
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  // import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then disable the following:
  // installComponents: true,
})


Vue.config.productionTip = false
window.Event = new Vue();
new Vue({
  router,
  store,
  vuetify,
  Carousel3d,
  render: h => h(App)
}).$mount('#app')
